module.exports = __webpack_public_path__ + "img/member2.bd9a99ec.png";